import { h } from 'vue'
import { getValueByPath, setValueByPathToVue } from '../../../utils/index'
import { useTemplate, useBeforValueActions } from '../../../hooks/index'
import { PgReadTextEditStyle } from '../../read-text/index'

export default {
  props: {
    column: Object,
    row: Object,
    extendCompileData: Object,
    treeNode: String,
    masterNotShowFields: Array,
    editCell: Boolean,
  },
  setup(props, { emit }) {
    const { beforActions } = useBeforValueActions()
    const { getTemplateData, compileData } = useTemplate()
    const propsColumn = props.column
    const {
      parentHide,
      childHide,
      changeBorthers,
      beforValueAction,
      editRowParam,
      fields,
      ...parameter
    } = propsColumn.parameter ?? {}
    return () => {
      console.log('render-cell')

      const propsCompileData = getTemplateData(null, { row: props.row, ...props.extendCompileData })
      // 支持单元格渲染多字段
      if (!props.editCell && fields && fields.length > 0) {
        const fieldsCompile = compileData(fields, propsCompileData)
        const nodes = fieldsCompile.map((field) => {
          return h(field.componentCode ?? props.column.componentCode ?? 'PgReadText', {
            style: field.style,
            attrs: {
              value: getValueByPath(props.row, field.property),
              ...parameter,
              ...field.props,
            },
          })
        })
        return h('span', { style: { display: 'flex', flexFlow: 'column' } }, nodes)
      }

      const childProps = compileData(
        !props.editCell ? parameter : editRowParam?.props ?? {},
        propsCompileData
      )
      //如果配置【是否禁止编辑】为是则不允许编辑
      if (propsColumn.disabled) {
        childProps.disabled = propsColumn.disabled
      }

      if (
        !props.row.master &&
        props.masterNotShowFields &&
        props.masterNotShowFields.includes(propsColumn.property)
      ) {
        return h('span', ['-'])
      } else if (props.treeNode && props.row.children?.length > 0 && parentHide) {
        return h('span', ['-'])
      } else if (props.treeNode && props.row._PARENT && childHide) {
        return h('span', ['-'])
      }
      // 当表格支持点击编辑时，对展示的组件做处理
      const renderComponent =
        !!editRowParam &&
        (propsColumn.componentCode === 'PgReadText' || propsColumn.componentCode === 'readText')
          ? PgReadTextEditStyle
          : propsColumn.componentCode
      return h(!props.editCell ? renderComponent ?? 'PgReadText' : editRowParam?.componentCode, {
        style: propsColumn.style,
        attrs: { value: getValueByPath(props.row, propsColumn.property), ...childProps },
        on: {
          input: (val) => {
            beforActions({
              val,
              beforValueAction: compileData(beforValueAction, propsCompileData),
              field: propsColumn.property,
              formTableProperty: props.extendCompileData?.property,
              row: props.row,
              callback(resVal) {
                setValueByPathToVue(props.row, propsColumn.property, resVal)
                if (changeBorthers) {
                  const temp = {}
                  Object.keys(changeBorthers).forEach((im) => {
                    let otherFields = changeBorthers[im]
                    if (!otherFields) {
                      temp[im] = otherFields
                    } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
                      temp[im] = compileData(otherFields, propsCompileData)
                    } else {
                      temp[im] = getValueByPath(resVal, otherFields)
                    }
                  })
                  Object.keys(temp).forEach((im) => {
                    setValueByPathToVue(props.row, im, temp[im])
                  })
                }
              },
              // 将change事件保证在after执行后再触发
              emitChange(resVal) {
                emit('change', resVal)
              },
            })
          },
        },
      })
    }
  },
}
